import React, { useEffect } from 'react';
import { useSelector } from 'react-redux'
import { LogManagerConsole } from 'Core/logManager';

/**
 * Splits a comma-separated option string (siteOptions / options) into a clean array.
 * Pendo list metadata must be an array of strings, so every value is coerced to string.
 */
export const splitOptions = (value) => {
  if (value === null || value === undefined || value === '') return [];
  return String(value)
    .split(',')
    .map(option => option.trim())
    .filter(Boolean);
};

/**
 * Builds the visitor permissions list sent to Pendo:
 * account-level site options followed by sub-user (numeric) permissions.
 */
export const buildPermissions = (user) => [
  ...splitOptions(user?.siteOptions),
  ...splitOptions(user?.options)
];

const ThirdPartyApi = () => {
  const { user } = useSelector(state => state.securityRedux)
  let sm = localStorage.getItem("sm")

  let authenticatedId = "company-" + user.companyId + (user.subUserId ? "-user-" + user.subUserId : "")

  useEffect(() => {
    if (!sm) {
      const pendoPayload = {
        visitor: {
          id: authenticatedId,   // Required if user is logged in
          email: user.email,        // Recommended if using Pendo Feedback, or NPS Email
          full_name: user.fullName,    // Recommended if using Pendo Feedback
          // role:         // Optional
          username: user.username,
          isSubUser: user.isSubUser,
          environment: process.env.ENVIROMENT,
          permissions: buildPermissions(user) // siteOptions + sub-user permissions

          // You can add any additional visitor level key-values here,
          // as long as it's not one of the above reserved names.
        },

        account: {
          id: user.companyId, // Highly recommended
          name: user.companyName,// Optional
          // is_paying:    // Recommended if using Pendo Feedback
          // monthly_value:// Recommended if using Pendo Feedback
          // planLevel:    // Optional
          // planPrice:    // Optional
          creationDate: user.createdOn,// Optional
          unitsCount: user.unitsCount,
          dealerId: user.dealerId,
          packageId: user.packageId,
          packageName: user.packageName
          // You can add any additional account level key-values here,
          // as long as it's not one of the above reserved names.
        }
      };

      // Debug: only printed when localStorage "debug" is set and "logKeys" is empty or includes "PENDO"
      LogManagerConsole('PENDO', 'initialize payload', pendoPayload);

      /*global pendo*/
      pendo.initialize(pendoPayload);
    }

    return () => {
      //shutdown();
    };

  }, []);

  return (
    <div> </div>
  )
}

export default ThirdPartyApi;